import lodash from "lodash";
const _RicosTextStyle = class _RicosTextStyle {
  constructor(textStyle) {
    this.getTextStyle = () => this.textStyle;
    this.toCustomStyle = () => {
      return { lineHeight: this.textStyle.lineHeight };
    };
    this.overrideWith = (textStyle) => {
      return _RicosTextStyle.of({ ...this.textStyle, ...textStyle });
    };
    this.textStyle = lodash.pickBy(textStyle);
  }
  static of(textStyle) {
    return new _RicosTextStyle(textStyle || {});
  }
};
_RicosTextStyle.fromCustomStyle = (customStyle) => {
  const { lineHeight } = customStyle;
  const textStyle = { lineHeight };
  return _RicosTextStyle.of(textStyle);
};
let RicosTextStyle = _RicosTextStyle;
export {
  RicosTextStyle
};
//# sourceMappingURL=text-style.js.map
